import { ProjectVersionHistoryAction } from '../actions/ProjectVersionHistoryAction';
import { ProjectVersionHistoryActionType } from '../actionTypes/projectVersionHistory';
import { ProjectVersionsHistory } from '../types';

interface ProjectVersionHistoryState {
    [projectId: string]: ProjectVersionsHistory;
}

const ProjectVersionsHistoryReducer = (
    state: ProjectVersionHistoryState = {},
    action: ProjectVersionHistoryAction
) => {
    const projectVersion = action.payload as ProjectVersionsHistory;
    switch (action.type) {
        case ProjectVersionHistoryActionType.GET_PROJECT_VERSION_HISTORY:
            return {
                ...state,
                [projectVersion.projectId]: projectVersion,
            };
        default:
            return state;
    }
};

export default ProjectVersionsHistoryReducer;
